import contact from './lib/contact'
import rebox from './lib/rebox'
import { toggleBelowFold, scrollSpy, smoothScroll } from './lib/scroll'

import { Splide } from '@splidejs/splide'

$(document).ready(function () {
  contact('#contact-form')
  rebox('.instanode-headstart-thumbimage')
  toggleBelowFold()
  // scrollSpy('.header-nav-sub:visible', {offset: 0})
  // smoothScroll('a[href^="#"]', {offset: 0})

  $(window).scroll(function () {
    if ($(this).scrollTop() >= 600) {
      $('.back-to-top').fadeIn(300).addClass('visible')
    } else {
      $('.back-to-top').fadeOut(300).removeClass('visible')
    }
  })
})

document.addEventListener('DOMContentLoaded', function () {
  const elementIconSlider = document.querySelector('.information-slider')
  if (elementIconSlider) {
    console.log('Element gefunden:', elementIconSlider)
    const splide = new Splide('.splide.information', {
      perPage: 2,
      perMove: 2,
      gap: 20,
      mediaQuery: 'max',
      breakpoints: {
        1024: {
          perPage: 2,
          perMove: 2,
          padding: '2rem',
          gap: 33
        },
        500: {
          padding: '1rem'
        }
      }
    })
    splide.mount()
  } else {
    console.log('Kein Element mit der Klasse "information" gefunden.')
  }
})

$(document).ready(function () {
  // Add or remove class 'active' to/from sections based on scroll position
  const allContainer = document.querySelectorAll('.grid-content')

  window.onscroll = function () {
    allContainer.forEach(section => {
      const rect = section.getBoundingClientRect()
      if (rect.top <= 800 && rect.bottom > 0) {
        // Add 'active' if the section is in the viewport
        section.classList.add('active')
      } else {
        // Remove 'active' if the section is out of the viewport
        section.classList.remove('active')
      }
    })
  }
})

document.addEventListener('DOMContentLoaded', function () {
  // Mapping von Font-Weight-Bezeichnern zu numerischen Werten
  const fontWeightMap = {
    thin: 100,
    extralight: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800
  }

  // Liste der CSS Custom Properties, die ersetzt werden sollen
  const variablesToReplace = [
    '--body-text-font-weight',
    '--headline-one-font-weight',
    '--headline-two-font-weight',
    '--headline-three-font-weight',
    '--headline-four-font-weight'
  ]

  // Alle <style>-Tags im <head> holen
  const styleTags = document.head.querySelectorAll('style')

  // Durch alle <style>-Tags iterieren
  for (let i = 0; i < styleTags.length; i++) {
    const styleTag = styleTags[i]
    const cssContent = styleTag.textContent

    // Suchen nach dem body-Block
    const bodyRuleMatch = cssContent.match(/body\s*\{([^}]+)\}/)

    if (bodyRuleMatch) {
      let bodyStyles = bodyRuleMatch[1]

      // Jede Variable prüfen und ggf. ersetzen
      for (let j = 0; j < variablesToReplace.length; j++) {
        const variable = variablesToReplace[j]

        // RegEx um den Wert der CSS-Variable zu finden
        const regex = new RegExp(variable + '\\s*:\\s*([^;]+);?')
        const match = bodyStyles.match(regex)

        if (match) {
          const keyword = match[1].trim().toLowerCase()
          const numericValue = fontWeightMap[keyword] || 400

          // Variable im CSS ersetzen
          const replacement = variable + ': ' + numericValue + ';'
          bodyStyles = bodyStyles.replace(regex, replacement)
        }
      }

      // Den aktualisierten body-Block im gesamten CSS ersetzen
      const updatedCss = cssContent.replace(/body\s*\{[^}]+\}/, 'body {' + bodyStyles + '}')

      // Zurückschreiben in das <style>-Tag
      styleTag.textContent = updatedCss

      // Nur das erste relevante <style>-Tag bearbeiten
      break
    }
  }
})

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header')
  if (!header) return

  const topItems = [...header.querySelectorAll('.header-nav-list > li')]
  const secondDropdownItems = [...header.querySelectorAll('.second-level > li.second-level-dropdown')]

  // Tuning (gute Startwerte)
  const OPEN_DELAY_TOP = 500 // Wechsel L1 -> L1 (Hover-Intent)
  const OPEN_DELAY_SECOND = 600 // Wechsel L2 -> L2 (Hover-Intent)
  const STICKY_DELAY_TOP = 500 // L1 bleibt kurz aktiv (kein hartes Close-Delay, sondern "sticky")
  const STICKY_DELAY_SECOND = 600 // L2 bleibt kurz aktiv ("sticky")

  let activeTop = null
  let activeSecond = null

  let openTopTimer = null
  let openSecondTimer = null
  let stickyTopTimer = null
  let stickySecondTimer = null

  // --- a11y helper -----------------------------------------------------------
  function setExpanded (li, expanded) {
    const trigger = li.querySelector(':scope > a')
    if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false')
  }

  // --- timers ----------------------------------------------------------------
  function clearTimer (ref) {
    if (ref) clearTimeout(ref)
    return null
  }

  function cancelTopOpen () { openTopTimer = clearTimer(openTopTimer) }
  function cancelSecondOpen () { openSecondTimer = clearTimer(openSecondTimer) }
  function cancelTopSticky () { stickyTopTimer = clearTimer(stickyTopTimer) }
  function cancelSecondSticky () { stickySecondTimer = clearTimer(stickySecondTimer) }

  // --- close/open primitives -------------------------------------------------
  function closeSecondImmediate () {
    cancelSecondOpen()
    cancelSecondSticky()
    if (!activeSecond) return
    activeSecond.classList.remove('is-open')
    setExpanded(activeSecond, false)
    activeSecond = null
  }

  function closeTopImmediate () {
    cancelTopOpen()
    cancelTopSticky()
    closeSecondImmediate()
    if (!activeTop) return
    activeTop.classList.remove('is-open')
    setExpanded(activeTop, false)
    activeTop = null
  }

  function scheduleStickyCloseTop (expectedTop) {
    cancelTopSticky()
    stickyTopTimer = window.setTimeout(() => {
      // Schließe nur, wenn immer noch dasselbe Item aktiv ist
      if (activeTop && activeTop === expectedTop) {
        closeTopImmediate()
      }
    }, STICKY_DELAY_TOP)
  }

  function scheduleStickyCloseSecond (expectedSecond) {
    cancelSecondSticky()
    stickySecondTimer = window.setTimeout(() => {
      if (activeSecond && activeSecond === expectedSecond) {
        closeSecondImmediate()
      }
    }, STICKY_DELAY_SECOND)
  }

  function openTopImmediate (li) {
    if (!li?.querySelector('.second-level-sub-navigation')) return

    cancelTopSticky()
    cancelSecondSticky()

    // Beim echten Wechsel: vorheriges Top schließen (inkl. Second)
    if (activeTop && activeTop !== li) closeTopImmediate()

    li.classList.add('is-open')
    setExpanded(li, true)
    activeTop = li
  }

  function openSecondImmediate (li) {
    if (!li?.querySelector('.third-level--wrapper')) return

    cancelSecondSticky()
    cancelTopSticky()

    // passendes Top offen halten/öffnen
    const parentTop = li.closest('.header-nav-list > li')
    if (parentTop) openTopImmediate(parentTop)

    if (activeSecond && activeSecond !== li) {
      activeSecond.classList.remove('is-open')
      setExpanded(activeSecond, false)
    }

    li.classList.add('is-open')
    setExpanded(li, true)
    activeSecond = li
  }

  // --- hover intent (delayed open on sibling switching) ----------------------
  function openTopWithIntent (li) {
    if (!li?.querySelector('.second-level-sub-navigation')) return

    cancelTopOpen()
    cancelTopSticky()

    const needsDelay = activeTop && activeTop !== li
    if (!needsDelay) return openTopImmediate(li)

    openTopTimer = window.setTimeout(() => {
      if (li.matches(':hover')) openTopImmediate(li)
    }, OPEN_DELAY_TOP)
  }

  function openSecondWithIntent (li) {
    if (!li?.querySelector('.third-level--wrapper')) return

    cancelSecondOpen()
    cancelSecondSticky()

    const needsDelay = activeSecond && activeSecond !== li
    if (!needsDelay) return openSecondImmediate(li)

    openSecondTimer = window.setTimeout(() => {
      if (li.matches(':hover')) openSecondImmediate(li)
    }, OPEN_DELAY_SECOND)
  }

  // Init aria-expanded
  topItems.forEach(li => setExpanded(li, false))
  secondDropdownItems.forEach(li => setExpanded(li, false))

  // --- mouse interactions ----------------------------------------------------
  // Level 1
  topItems.forEach((li) => {
    li.addEventListener('mouseenter', () => {
      // Wenn wir gerade von einem Item kommen, lassen wir es kurz "sticky" offen
      // und öffnen das neue erst nach intent-delay
      openTopWithIntent(li)
    })

    li.addEventListener('mouseleave', () => {
      cancelTopOpen()
      // ✅ Sticky: vorher aktives Top bleibt kurz offen (damit diagonale Wege möglich sind)
      if (activeTop === li) scheduleStickyCloseTop(li)
    })
  })

  // Level 2 (Third Level opener)
  secondDropdownItems.forEach((li) => {
    const thirdWrapper = li.querySelector('.third-level--wrapper')
    if (!thirdWrapper) return

    let isInThird = false

    li.addEventListener('mouseenter', () => {
      cancelSecondSticky()
      openSecondWithIntent(li)
    })

    li.addEventListener('mouseleave', (e) => {
      cancelSecondOpen()

      const to = e.relatedTarget
      // Direkt ins 3rd-Level => nicht sticky schließen
      if (to && (to === thirdWrapper || thirdWrapper.contains(to))) return

      // ✅ Sticky: bleibt kurz offen, um diagonal ins 3rd-Level zu kommen
      if (activeSecond === li) scheduleStickyCloseSecond(li)
    })

    thirdWrapper.addEventListener('mouseenter', () => {
      isInThird = true
      cancelSecondSticky()
      cancelSecondOpen()
      openSecondImmediate(li) // keep open
    })

    thirdWrapper.addEventListener('mouseleave', (e) => {
      isInThird = false
      const to = e.relatedTarget

      // Zurück ins li => offen lassen
      if (to && li.contains(to)) return

      // ✅ Sticky beim Verlassen des 3rd-Level (kurzes "stehen lassen")
      if (activeSecond === li) scheduleStickyCloseSecond(li)
    })
  })

  // Header verlassen: alles zu (mit Sticky, damit kleine Ausreißer nicht sofort zuklappen)
  header.addEventListener('mouseleave', () => {
    if (activeSecond) scheduleStickyCloseSecond(activeSecond)
    if (activeTop) scheduleStickyCloseTop(activeTop)
  })

  header.addEventListener('mouseenter', () => {
    cancelTopSticky()
    cancelSecondSticky()
  })

  // --- keyboard / focus interactions (Tab) ----------------------------------
  // Keyboard öffnet immer sofort (keine Verzögerung, keine Sticky-Spielchen)
  header.addEventListener('focusin', (e) => {
    cancelTopSticky()
    cancelSecondSticky()
    cancelTopOpen()
    cancelSecondOpen()

    const target = e.target
    const secondLi = target.closest('.second-level > li.second-level-dropdown')
    if (secondLi && header.contains(secondLi)) {
      openSecondImmediate(secondLi)
      return
    }

    const topLi = target.closest('.header-nav-list > li')
    if (topLi && header.contains(topLi)) openTopImmediate(topLi)
  })

  header.addEventListener('focusout', (e) => {
    const to = e.relatedTarget

    if (!to || !header.contains(to)) {
      closeTopImmediate()
      return
    }

    if (activeSecond) {
      const thirdWrapper = activeSecond.querySelector('.third-level--wrapper')
      const stillInsideSecond =
        activeSecond.contains(to) || (thirdWrapper && thirdWrapper.contains(to))
      if (!stillInsideSecond) closeSecondImmediate()
    }

    if (activeTop && !activeTop.contains(to)) closeTopImmediate()
  })

  header.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return
    closeTopImmediate()

    const firstLink = header.querySelector('.header-nav-list > li > a')
    if (firstLink) firstLink.focus()
  })
})

document.addEventListener('DOMContentLoaded', function () {
  const mobileDropdowns = document.querySelectorAll('.dropdown-mobile')

  // 1. mobile-parent-link (innerer echter Link) darf nicht verhindern, darf aber kein Dropdown öffnen
  document.querySelectorAll('.mobile-parent-link a').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.stopPropagation() // Klick bleibt in der Ebene
    })
  })

  // 2. Dropdown öffnen/schließen
  mobileDropdowns.forEach(function (item) {
    // Der Klick soll NICHT hochwandern zu anderen dropdown-mobile
    item.addEventListener('click', function (e) {
      if (window.innerWidth >= 1200) return

      // Wenn ein echter Link im Dropdown geklickt wurde → Dropdown NICHT toggeln
      if (e.target.closest('a') && !e.target.closest('.level1-link')) {
        e.stopPropagation()
        return
      }

      // verhindern, dass der Klick Eltern-Dropdowns triggert
      e.stopPropagation()

      // Level-1-Link (der deaktivierte) soll nicht navigieren
      if (e.target.closest('.level1-link')) {
        e.preventDefault()
      }

      // Toggle nur auf diesem Element
      item.classList.toggle('open')
    })
  })

  // 3. body klick soll andere dropdowns NICHT schließen
  //    wir schließen nur, wenn du das willst – aktuell nicht nötig
})

function updateNavOffsets () {
  if (window.innerWidth < 1200) return

  const header = document.querySelector('.header')
  const secondLevel = document.querySelector('.second-level-sub-navigation')

  if (header) {
    const h = header.offsetHeight
    document.querySelectorAll('.second-level-sub-navigation')
      // eslint-disable-next-line no-return-assign
      .forEach(el => el.style.top = `${h}px`)
  }

  if (secondLevel) {
    const h = secondLevel.offsetHeight
    document.querySelectorAll('.third-level--wrapper')
      // eslint-disable-next-line no-return-assign
      .forEach(el => el.style.top = `${h}px`)
  }
}

document.addEventListener('DOMContentLoaded', updateNavOffsets)
window.addEventListener('resize', updateNavOffsets)
